import type {
  ApiDrawdownInvestor,
  ApiDrawdownPayment,
  DrawdownInvestor,
  DrawdownPayment,
} from '@/types/drawdown';
import { toNumber } from '@/utils/number-operations';

export function mapDrawdownInvestor(
  raw: ApiDrawdownInvestor
): DrawdownInvestor {
  return {
    ...raw,
    commitment_amount: toNumber(raw.commitment_amount),
    drawdown_percentage: toNumber(raw.drawdown_percentage),
    drawdown_amount: toNumber(raw.drawdown_amount),
    amount_paid: toNumber(raw.amount_paid),
    late_fee_amount: toNumber(raw.late_fee_amount),
    payments: (raw.payments ?? []).map(mapDrawdownPayment),
  };
}

function mapDrawdownPayment(raw: ApiDrawdownPayment): DrawdownPayment {
  return {
    ...raw,
    amount: toNumber(raw.amount),
  };
}
